"use client";

import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks.ts";
import { useEffect } from "react";
import { getUserVoip } from "@/redux/slices/user/thunks/getUserVoip.ts";
import { getPlanPrices } from "@/redux/slices/store/thunks/getPlanPrices.ts";
import { getSiteVersion } from "@/redux/slices/store/thunks/getSiteVersion.ts";
import * as S from "./styles.ts";
import {
  StoreThemeContextProvider,
  StoreThemeProvider,
} from "@template/providers/StoreThemeProvider.tsx";
import { getTlds } from "@/redux/slices/store/thunks/getTlds.ts";

interface IRootSiteLayoutProps {
  children: any;
}

const RootSiteLayout = ({ children }: IRootSiteLayoutProps) => {
  const user = useTypedSelector((state) => state.user);

  const dispatch = useTypedDispatch();

  useEffect(() => {
    dispatch(getUserVoip());
  }, [user.cart?.items.length]);

  useEffect(() => {
    dispatch(getPlanPrices());
    dispatch(getSiteVersion());
  }, [user.user?.uuid]);

  useEffect(() => {
    dispatch(getTlds());
  }, []);

  return (
    <StoreThemeContextProvider>
      <StoreThemeProvider>
        <S.Wrapper>{children}</S.Wrapper>
      </StoreThemeProvider>
    </StoreThemeContextProvider>
  );
};

export default RootSiteLayout;
